<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'MaDianjianInput',
})
</script>
<template>
	<el-input v-model="userName" :clearable :disabled :placeholder @clear="model = ''">
		<template #append>
			<el-button icon="Search" @click="visible = true" />
		</template>
	</el-input>
	<ma-dianjian-dialog v-if="!disabled && visible" :key="visible" v-model="visible" :multiple @select="userHandle"></ma-dianjian-dialog>
</template>

<script setup lang="ts" name="MaDianjianInput">
import { ref, watch } from 'vue'
// import { useRealNameListApi } from '@/api/sys/user'
import { apiRequest } from '@/api/common'
const props = defineProps({
	multiple: {
		type: Boolean,
		required: false,
		default: false
	},
	clearable: {
		type: Boolean,
		required: false,
		default: () => true
	},
	disabled: {
		type: Boolean,
		required: false,
		default: () => false
	},
	placeholder: {
		type: String,
		required: false,
		default: () => ''
	}
})

const model = defineModel<any | any[]>()
const visible = ref(false)
const userName = ref()

watch(
	() => model.value,
	async val => {
		if (val) {
			if (props.multiple && typeof val === 'string') {
				val = val.split(',')
			}
			const idList = val
			if (idList.length > 0) {
				apiRequest('POST', 'maku/biz_device_check_project_item/findProjectItemNameList', props.multiple ? idList : [idList]).then(res => {
					userName.value = res.data.join(',')
				})
			} else {
				userName.value = ''
			}
		} else {
			userName.value = ''
		}
	},
	{
		immediate: true
	}
)
const emit = defineEmits(['select'])
const userHandle = (rows: any[]) => {
	if (props.multiple) {
		model.value = rows.map((item: any) => item.id)
	} else {
		model.value = rows[0].id
	}
	emit('select', rows)
}
const getDeviceList = () => {
	// apiRequest('post', '')
}
</script>
